module.exports = __webpack_public_path__ + "img/16_20.25960f10.png";